<template>
    <v-img :src="image" class="container image elevation-3" position="center top" />
    <!-- <div class="label-box-container">
      <div class="label-box error">
        <div class="headline">{{ aum | currency }}</div>
        <span>AUM</span>
      </div>
      <div class="label-box secondary">
        <div class="headline">{{ revenue | currency }}</div>
        <span>Revenue</span>
      </div>
      <div class="label-box primary">
        <div class="headline text-center">{{ type }}</div>
        <span>Listing</span>
      </div>
    </div> -->
</template>

<script>
export default {
  name: 'BuyerListingDetailsHeaderImage',
  props: {
    image: String,
    // aum: String,
    // revenue: String,
    // type: String,
    // title: String,
    // content: String
  }
}
</script>

<style scoped>
.container {
  margin: 20px 0;
  width: 100%;
}

.image {
  height: auto;
}

/* .buyer-header-image .label-box-container {
  height: 100%;
  width: 34%;
  display: block;
}

.buyer-header-image .label-box {
  height: 33.33%;
  width: 100%;
  padding: 10px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-bottom: 1px solid transparent;

  color: white;
}

.buyer-header-image .label-box:not(:last-child) {
  border-bottom-color: #707070 !important;
}

.buyer-header-image .label-box .headline {
  flex-grow: 1;
  display: flex;
  align-items: center;

  font-size: 26px !important;
  font-weight: bold;
}

.buyer-header-image .label-box span {
  font-family: 'AvenirMedium', sans-serif;
  font-size: 18px;
} */
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/header-image.vue